import { FC, useState } from "react";
import ButtonComponent from "../../../../../../../common/components/button/button.component";
import ModalComponent, {
  ModalProps,
} from "../../../../../../../common/components/modal/modal.component";
import DriverDetailsDriverPlanEntry, {
  DriverDetailsDriverPlanEntryWaypoint,
} from "../../common/types/driver-details-plan-entry";
import userTranslationsHelper from "../../../../../../../languages/user-translations.helper";
import notificationService from "../../../../../../../common/utils/notification/notification.service";
import DriverPlanEntryCheckoutEventDeleteParams from "../../../../../../../common/services/driver/plan-entry/checkout-event/delete/driver-plan-entry-checkout-event-delete-params";
import useAbort from "../../../../../../../common/hooks/use-abort";
import driverService from "../../../../../../../common/services/driver/driver.service";

type DriverDetailsPlanDeleteCheckoutProps = Pick<
  ModalProps,
  "isOpen" | "onClose"
> & {
  onDeleteCheckoutSuccess: () => void;
  driverUuid: string;
  planEntry: DriverDetailsDriverPlanEntry | undefined;
  waypoint: DriverDetailsDriverPlanEntryWaypoint | undefined;
  checkoutEventUuid: string;
};

const DriverDetailsPlanDeleteCheckoutComponent: FC<
  DriverDetailsPlanDeleteCheckoutProps
> = (props) => {
  const translations =
    userTranslationsHelper.getDriverDetailsActiveRoutePlansTranslations()
      .deleteCheckout;

  const [isCheckoutDeleteFetching, setIsCheckoutDeleteFetching] =
    useState(false);

  const deleteCheckoutEventAbort = useAbort();

  const onDeleteCheckoutSuccess = () => {
    notificationService.success(translations.successNotificationText);
    props.onDeleteCheckoutSuccess();
  };

  const onDeleteCheckoutFailure = () => {
    notificationService.error(translations.failureNotificationText);
  };

  const deleteCheckout = () => {
    if (
      !props.driverUuid ||
      !props.planEntry?.uuid ||
      !props.checkoutEventUuid
    ) {
      return;
    }

    setIsCheckoutDeleteFetching(true);

    const params: DriverPlanEntryCheckoutEventDeleteParams = {
      checkoutEventUuid: props.checkoutEventUuid,
      driverUuid: props.driverUuid,
      planEntryUuid: props.planEntry.uuid,
    };

    driverService
      .deleteCheckoutEvent(params, deleteCheckoutEventAbort.signal)
      .then(onDeleteCheckoutSuccess)
      .catch(onDeleteCheckoutFailure)
      .finally(() => setIsCheckoutDeleteFetching(false));
  };

  const onSubmitButtonClick = () => {
    deleteCheckout();
  };

  if (!props.waypoint || !props.planEntry) {
    return null;
  }

  return (
    <ModalComponent
      header={{ title: translations.headingText }}
      isOpen={props.isOpen}
      onClose={props.onClose}
      actions={[
        <ButtonComponent
          onClick={onSubmitButtonClick}
          type="danger"
          isLoading={isCheckoutDeleteFetching}
          title={translations.submitButtonTitle}
        >
          {translations.submitButtonText}
        </ButtonComponent>,
        <ButtonComponent
          onClick={props.onClose}
          type="brand"
          title={translations.rejectButtonTitle}
        >
          {translations.rejectButtonText}
        </ButtonComponent>,
      ]}
    >
      <div>
        <div>
          {translations.addressTemplateText.replace(
            "#{addressDisplayName}",
            props.waypoint.address.displayName,
          )}
        </div>
        <div>
          {translations.contentMessageTemplateText.replace(
            "#{planEntryId}",
            String(props.planEntry.id),
          )}
        </div>
      </div>
    </ModalComponent>
  );
};

export default DriverDetailsPlanDeleteCheckoutComponent;
